import { useState, useEffect } from "react";

export type MetricViewMode = "circles" | "list";

/**
 * Hook to manage the user's preferred metric view mode (circles or list).
 * Persists the preference in localStorage with a user-specific key.
 */
export function useMetricViewMode(userId: string | undefined): [MetricViewMode, (mode: MetricViewMode) => void] {
  const [viewMode, setViewModeState] = useState<MetricViewMode>("list");

  // Load preference on mount
  useEffect(() => {
    if (!userId) return;
    
    const storageKey = `metric_view_mode_${userId}`;
    const savedMode = localStorage.getItem(storageKey);
    
    if (savedMode === "circles" || savedMode === "list") {
      setViewModeState(savedMode);
    }
  }, [userId]);

  // Function to update view mode and persist to localStorage
  const setViewMode = (mode: MetricViewMode) => {
    if (!userId) return;
    
    setViewModeState(mode);
    const storageKey = `metric_view_mode_${userId}`;
    localStorage.setItem(storageKey, mode);
  };

  return [viewMode, setViewMode];
}
